import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '../__root';

const completeProfileSearchSchema = z.object({
  token: z.string().optional(),
  name: z.string().optional(),
});

export const completeProfileRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth/complete-profile',
  validateSearch: completeProfileSearchSchema,
  component: lazyRouteComponent(
    () => import('@/features/auth/CompleteProfilePage'),
    'CompleteProfilePage',
  ),
});
